<section class="diamond-shapes-group">
  <article class="single-diamond-shape" *ngFor="let shape of shapes">
    <svg-icon [key]="shape.shapeNameIcon"></svg-icon><span>{{shape.name}}</span>
  </article>
</section>
